export default __webpack_public_path__ + "static/media/Picture2.b901a94f.png";